import { createFileRoute } from "@tanstack/react-router";
import { Dot } from "lucide-react";

import { Stats } from "@/components/brand-governance/creative-monitor/stats";
import { BrandCheck } from "@/components/brand-governance/creative-monitor/brand-check";

import { useSession } from "@/hooks/use-session";
import { PageHeader } from "@/components/layout/heading";

export const Route = createFileRoute("/dashboard/governance/_layout/creative-monitor")({
  component: CreativeMonitor,
});

export function CreativeMonitor() {
  const session = useSession();
  const brandName = session.profile.company?.company_name ?? "";



  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2 justify-between">
        <PageHeader title="Live creative monitor" />
        <div className="flex items-center text-sm text-success">
          <Dot strokeWidth={8} />
          Live
        </div>
      </div>
      <Stats params={{ brand_name: brandName }} />
      <BrandCheck params={{ brand_name: brandName }} />
    </div>
  );
}
